import styled from 'styled-components';
import { Container } from '../Container/Container';
import { UnstyledButtonLink } from '../ButtonLink/ButtonLink';
import { ReactComponent as LoginIcon } from '../../assets/icons/login.svg';
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg';
import { useAuth } from "../../contexts/auth-context";
import { useLocation } from "react-router-dom";

const StyledLoginBar = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    background-color: var(--color-green-40);
`;

const Flex = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
    
    @media screen and (max-width: 475px) {
        height: 30px;
        display: none;
    }
`;

const LoginButton = styled(UnstyledButtonLink)`
    font-size: var(--fs-navigation-small);
    color: var(--color-white);
    display: flex;
    align-items: center;
    gap: 8px;

    text-decoration: ${props => props.$active ? 'underline' : 'none'};
    text-underline-offset: 1.5px;

    &:hover {
        text-decoration: underline;
    }
    
    svg {
        fill: var(--color-white);
        width: 20px;
        height: 20px;
    }
`;

const NavButton = styled(UnstyledButtonLink)`
    font-weight: var(--fw-semi-bold);
    font-size: var(--fs-navigation-small);
    color: var(--color-white);
    margin-right: 24px;
    text-decoration: ${props => props.$active ? 'underline' : 'none'};
    text-underline-offset: 1.5px;
    
    &:hover {
        text-decoration: underline;
    }
    
    @media screen and (max-width: 475px) {
        margin-right: 12px;
    }
`;

const LoginBar = () => {
    const { logout, isAuthenticated } = useAuth();
    const {pathname} = useLocation();

    // Hide on student file page
    const splitPathname = pathname.split("/").filter(Boolean);
    if (splitPathname[0] === "studenten" && splitPathname.length > 2) {
        return null;
    }

    return (
        <StyledLoginBar>
            <Container>

                <Flex>
                    { !isAuthenticated ? (
                        <LoginButton to="/inloggen" $active={pathname === '/inloggen'}>
                            <LoginIcon />
                            Inloggen voor recruiters
                        </LoginButton>
                    ) : (
                        <>
                            <NavButton to="/studenten" $active={pathname === '/studenten'}>
                                Studenten
                            </NavButton>
                            <LoginButton as="button" onClick={() => {logout()}}>
                                <LogoutIcon />
                                Uitloggen
                            </LoginButton>
                        </>
                    )}
                </Flex>

            </Container>
        </StyledLoginBar>
    )
}

export default LoginBar;